'use client';

import { AnchorMenuItem, anchorMenuItemTag } from '@ni/nimble-components/dist/esm/anchor-menu-item';
import { wrap } from '../utilities/react-wrapper';

export { anchorMenuItemTag };
export { type AnchorMenuItem };
export const NimbleAnchorMenuItem = wrap(AnchorMenuItem);
